export type SentryUser = { id: string }

/**
 * Maps auth state to the Sentry user identity, or null to clear it.
 *
 * The id is the backend `userid` (NOT the typed login username), so Sentry
 * events join 1:1 with the backend `clientlog` `id` (e.g. "janne", "linda") —
 * the only way to count distinct affected users and correlate `[update-health]`
 * errors with `[online-recovery]`/`[visit-self-heal]` clientlog lines.
 *
 * Must be driven by the rehydrated auth state, not only interactive sign-in:
 * these installed PWAs restore persisted auth on launch and almost never re-run
 * the login flow, which is why the old sign-in-only `Sentry.setUser` left every
 * event with no user (Sentry `count_unique(user) === 0`).
 */
export const sentryUserFor = (
  authenticated: boolean,
  userid: string
): SentryUser | null =>
  authenticated && userid.trim() !== '' ? { id: userid } : null
